import { useField, useFormikContext } from 'formik';

import React from 'react';
import { getAppText } from 'Utils/text';
import { getFieldError } from '../forms.helpers';
import { getOptions, getValue } from './radioButton.helpers';
import { useRadioButtonChangeHandler } from './radioButton.hooks';
import { StyledRadio } from './radioButton.styled';
import { FieldValue, Props } from './radioButton.types';

export const RadioButton = (props: Props) => {
  const {
    direction,
    error: overrideError,
    id,
    label,
    hint,
    name,
    disabled,
    maxLinesHint = 6,
    variant,
  } = props;
  const { submitCount } = useFormikContext();
  const [field, meta] = useField<FieldValue>(name);
  const handleChange = useRadioButtonChangeHandler(props);

  return (
    <StyledRadio
      name={name}
      value={getValue(variant, field.value)}
      id={id}
      onChange={handleChange}
      hint={hint}
      label={label}
      options={getOptions(props)}
      direction={direction}
      error={overrideError ?? getFieldError(meta, submitCount)}
      disabled={disabled}
      hintProps={{
        maxLines: maxLinesHint,
        readMoreLabel: getAppText('insurance_common.readMore'),
        readLessLabel: getAppText('insurance_common.readLess'),
      }}
    />
  );
};
